<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import CustomersComponent from './CustomersComponent.vue';

    export default {
    name: 'CustomersPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, CustomersComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <CustomersComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>
